import React from "react";
import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Residential Cleaning",
  description: "Comprehensive recurring and deep cleaning solutions tailored for your home.",
  detail: "Recurring & Deep Cleans",
  href: "/ServicesSectionPage"
}, {
  title: "Move-In / Move-Out",
  description: "Ensuring a spotless fresh start or a clean exit for homeowners and renters.",
  detail: "Transition Cleaning",
  href: "/ServicesSectionPage"
}, {
  title: "Commercial Cleaning",
  description: "Professional, reliable cleaning for small offices and business spaces.",
  detail: "Small Offices & Spaces",
  href: "/ServicesSectionPage"
}, {
  title: "Short-Term Rental",
  description: "Fast, precise turnover services designed for hosts and vacation rentals.",
  detail: "Turnover Cleaning",
  href: "/ServicesSectionPage"
}];
export default function ServicesOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}